import { render } from "./UITextArea.vue?vue&type=template&id=5602c801"
import script from "./UITextArea.vue?vue&type=script&lang=ts"
export * from "./UITextArea.vue?vue&type=script&lang=ts"
script.render = render

export default script